import { useTranslation } from "react-i18next";

import { SlottedWindow } from "components/window/SlottedWindow";
import { useWindowPlatformMode } from "components/window/useWindowPlatformMode";
import { type BaseWindowProps } from "contexts/windows";

import { SettingsContent } from "./components";

export function SettingsWindow({ onClose, position }: BaseWindowProps) {
    const { t } = useTranslation();
    const { isMobile } = useWindowPlatformMode();

    return (
        <SlottedWindow
            position={position}
            size={{ width: 400 }}
            autoHeight
            onClose={onClose}
            headerRegion={<SlottedWindow.Title>{t("settings")}</SlottedWindow.Title>}
            data-testid="settings-window"
        >
            <SettingsContent useSlideInPicker={isMobile} />
        </SlottedWindow>
    );
}
